import helpArticleData from './helpArticles.json';

export type HelpArticle = {
  slug: string;
  path: string;
  title: string;
  description: string;
  requirements?: string[];
  steps: Array<{
    title: string;
    body: string;
    doneWhen: string;
    image?: {
      src: string;
      alt: string;
    };
  }>;
  troubleshooting?: {
    title: string;
    body: string;
    actionLabel?: string;
  };
};

export const helpCenter = {
  path: '/help',
  title: 'Help Center',
  description: 'Step-by-step setup guides with a clear finish line.',
} as const;

export const helpArticles: HelpArticle[] = helpArticleData;

export function getHelpArticle(slug: string): HelpArticle {
  const article = helpArticles.find((candidate) => candidate.slug === slug);
  if (!article) throw new Error(`Unknown Help article: ${slug}`);
  return article;
}
